export const SERVICE_NAMES = {
  top3: 'Топ',
  premium: 'Премиум',
  'premium+highlight': 'Премиум с выделением цветом',
  paid: 'Платное',
};

export const getServicePackageName = (servicePackage) => {
  const serviceType = servicePackage.services.join('+');

  return SERVICE_NAMES[serviceType];
};
